import { ProcessExemptionCopayPayload } from '@/modules/copay/entities/interfaces/copaies';
import {
  UsageStatement,
  UsageStatementProcess,
  UsageStatementSearchParams,
} from '@/modules/copay/entities/interfaces/usageStatements';
import { BaseListResponse } from '@/shared/entities';
import HttpClientAdapter from '@/shared/services/httpClientAdapter';

export class CopayService extends HttpClientAdapter {
  constructor() {
    super('FINANCIAL');
  }

  getUsageStatements(
    filters: Partial<UsageStatementSearchParams>,
  ): Promise<BaseListResponse<UsageStatement>> {
    return this.get('/usage-statements', filters);
  }

  async getOneUsageStatement(usageStatementId: string): Promise<UsageStatement> {
    return this.get(`/usage-statements/${usageStatementId}`);
  }

  getUsageStatementProcesses(
    filters: Partial<UsageStatementSearchParams>,
  ): Promise<BaseListResponse<UsageStatementProcess>> {
    return this.get('/usage-statement-processes', filters);
  }

  async getOneUsageStatementProcess(
    usageStatementProcessId: string,
  ): Promise<UsageStatementProcess> {
    return this.get(`/usage-statement-processes/${usageStatementProcessId}`);
  }

  process(usageStatementProcessId: string, payload: ProcessExemptionCopayPayload) {
    return this.post(`/usage-statement-processes/${usageStatementProcessId}/process`, payload);
  }

  publish(usageStatementProcessId: string) {
    return this.post(`/processed-usage-statements/${usageStatementProcessId}/publish`);
  }

  release(usageStatementId: string) {
    return this.post(`/usage-statements/${usageStatementId}/release`);
  }

  update(usageStatementId: string, payload: Partial<UsageStatement>) {
    return this.patch(`/usage-statements/${usageStatementId}`, payload);
  }
}
